export const isEmptyCustomDataString = (value: string): boolean => {
  return ['', 'null', 'undefined', '{}', undefined].includes(value);
};

export const transformCustomData = (customData: object | object[] | null | undefined) => {
  const customDataValue = JSON.stringify(customData, null, 2);
  if (isEmptyCustomDataString(customDataValue)) {
    return {
      data: '',
      isEnabled: false,
    };
  }

  return {
    data: customDataValue,
    isEnabled: true,
  };
};
